import { render, staticRenderFns } from "./CertificateOrderDialog.vue?vue&type=template&id=259ab65a&scoped=true&"
import script from "./CertificateOrderDialog.vue?vue&type=script&lang=js&"
export * from "./CertificateOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259ab65a",
  null
  
)

export default component.exports